<div class="p-3 pt-2 rounded-4">
  <div>
    <div class="pTitle border-0 mb-0 rounded-bottom-0 rounded-4 p-0">
      <div class="p-3">Report</div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="row bg-white p-2 pt-0">
      <div class="col-md-4 mb-5 mt-4">
        <div class="form-group">
          <label class="required">From Date</label>
          <div class="input-group">
            <input class="form-control" name="from" #from="ngModel" [(ngModel)]="fromDate"
              autocomplete="off" (ngModelChange)="onFromDate($event)" ngbDatepicker #d1="ngbDatepicker"
              required>
            <span class="input-group-text pointer" (click)="d1.toggle()">
              <i class="bi bi-calendar"></i>
            </span>
          </div>
          @if (from.touched && from.invalid) {
            <div class="text-danger">
              From Date is required.
            </div>
          }
        </div>
      </div>
      <div class="col-md-4 mt-4">
        <div class="form-group">
          <label class="required">To Date</label>
          <div class="input-group">
            <input class="form-control" name="to" #to="ngModel" [(ngModel)]="toDate" autocomplete="off"
              ngbDatepicker #d2="ngbDatepicker" [minDate]="minToDate" required>
            <span class="input-group-text pointer" (click)="d2.toggle()">
              <i class="bi bi-calendar"></i>
            </span>
          </div>
          @if (to.touched && to.invalid) {
            <div class="text-danger">
              To Date is required.
            </div>
          }
        </div>
      </div>
      <div class="col-md-2 mt-4">
        <button [disabled]="!fromDate || !toDate" class="btn btn-primary mt-4 col-md-12" (click)="onSubmit()">
          Submit
        </button>
      </div>
    </div>
    @if (errorMessage) {
      <div class="row mt-3">
        <div class="col-md-12">
          <div class="alert alert-danger">{{ errorMessage }}</div>
        </div>
      </div>
    }
    @if (reportData && !reportData.error) {
      <div class="row mt-4">
        <div class="col-md-12">
          @if (reportData.data && reportData.data.length > 0) {
            <div class="table-responsive">
              <table class="table table-bordered table-striped">
                <thead>
                  <tr>
                    @for (key of reportKeys; track key) {
                      <th>{{ key }}</th>
                    }
                  </tr>
                </thead>
                <tbody>
                  @for (row of reportRows; track row) {
                    <tr>
                      @for (cell of row; track cell) {
                        <td>{{ cell }}</td>
                      }
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          } @else {
            <div class="alert alert-info">No data available for the selected date range.</div>
          }
        </div>
      </div>
    }
  </div>
</div>